import { createMuiTheme } from '@material-ui/core/styles';
import { colors } from '../constants/styleConstants';

export const themeObject = {
  props: {
    MuiButtonBase: {
      disableRipple: true,
    },
    MenuItem: {
      disableRipple: true,
      dense: true,
    },
    MuiTab: {
      selected: {
        color: colors.primary,
      },
    },
  },
  palette: {
    primary: {
      main: colors.primary,
      contrastText: colors.white,
    },
    secondary: {
      main: colors.blue,
    },
    error: {
      main: colors.red,
    },
    background: {
      default: '#fff',
    },
  },
};

// Create a theme instance.
const theme = createMuiTheme(themeObject);

export default theme;
